import React from "react";
import BlockInterface from '../editable_interface/BlockInterface/BlockInterface';
import Banner from '../components/Banner/Banner.js'
import './style.css';

export default function Shungubug() {
    /////////////////////////////////////////////////////////////////////////////
    let image_name = "shungubug.jpg";
    let is_video = false;
    /////////////////////////////////////////////////////////////////////////////
    return (
        <>
            <Banner src={image_name} isVideo={is_video}></Banner>
            <BlockInterface pageName="Shungubug"></BlockInterface>
        </>
    );
}
